<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createMenu',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="80%" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="用户名" name="username">
                    {{ props.detailData.nickname }}
                    <!-- {{ state.options }}
          <hr />
          {{ formState }} -->
                </a-form-item>
                <a-form-item label="平台" name="platform_id">
                    <a-select allow-clear @change="selectPlatformChange" style="width: 100%"
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model:value="formState.platform_id" placeholder="请选择平台简称">
                        <a-select-option class="relative" v-for="(item, index) in state.platformServicesList"
                            :key="index" :value="item.id" :title="item.platform_name">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <div v-if="formState.platform_id">
                    <a-form-item label="状态">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.status"></a-switch>
                    </a-form-item>
                    <a-form-item label="时间范围" name="between_time">
                        <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                            @change="rangTimeChange" :format="format"></a-range-picker>
                    </a-form-item>
                    <a-form-item label="公司价格" name="company_postfix">
                        <a-radio-group button-style="solid" v-model:value="formState.company_postfix_type">
                            <a-radio-button :value="1">自定义</a-radio-button>
                        </a-radio-group>
                        <div v-if="formState.company_postfix_type == 1"
                            v-for="(item, index) in formState.company_postfix_zdy" :key="index" class="phone-item"
                            style="margin-bottom: 20px; width: 900px">
                            <a-badge-ribbon placement="start">
                                <template #text>{{ item.name }}</template>
                                <a-row>
                                    <a-col :span="24"><a-divider :plain="true">↓</a-divider></a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="3">设立小规模包注册↓</a-col>
                                    <a-col :span="3">设立小规模裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">设立小规模一次性↓</a-col>
                                    <a-col :span="3">设立小规模续费↓</a-col>
                                    <a-col :span="3">迁入小规模包注册↓</a-col>
                                    <a-col :span="3">迁入小规模裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">迁入小规模一次性↓</a-col>
                                    <a-col :span="3">迁入小规模续费↓</a-col>
                                </a-row>
                                <a-row>
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="包注册价格" v-model:value="item.price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="裸地址价格"
                                            v-model:value="item.price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input placeholder="一次性价格"
                                            v-model:value="item.price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="续费价格"
                                            v-model:value="item.price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="包注册价格" v-model:value="item.price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="裸地址价格"
                                            v-model:value="item.price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input placeholder="一次性价格"
                                            v-model:value="item.price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="续费价格"
                                            v-model:value="item.price14"></a-input></a-col>
                                </a-row>
                                <a-row v-if="item.xukeddprice">
                                    <a-col :span="3">设立许可包注册↓</a-col>
                                    <a-col :span="3">设立许可裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">设立许可一次性↓</a-col>
                                    <a-col :span="3">设立许可续费↓</a-col>
                                    <a-col :span="3">迁入许可包注册↓</a-col>
                                    <a-col :span="3">迁入许可裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">迁入许可一次性↓</a-col>
                                    <a-col :span="3">迁入许可续费↓</a-col>
                                </a-row>
                                <a-row v-if="item.xukeddprice">
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="许可包注册价格" v-model:value="item.xk_price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="许可裸地址价格"
                                            v-model:value="item.xk_price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input
                                            placeholder="许可一次性价格" v-model:value="item.xk_price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="许可续费价格"
                                            v-model:value="item.xk_price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="许可包注册价格" v-model:value="item.xk_price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="许可裸地址价格"
                                            v-model:value="item.xk_price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input
                                            placeholder="许可一次性价格" v-model:value="item.xk_price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="许可续费价格"
                                            v-model:value="item.xk_price14"></a-input></a-col>
                                </a-row>
                                <a-row v-if="item.ybrddprice">
                                    <a-col :span="3">设立一般人包注册↓</a-col>
                                    <a-col :span="3">设立一般人裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">设立一般人一次性↓</a-col>
                                    <a-col :span="3">设立一般人续费↓</a-col>
                                    <a-col :span="3">迁入一般人包注册↓</a-col>
                                    <a-col :span="3">迁入一般人裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx">迁入一般人一次性↓</a-col>
                                    <a-col :span="3">迁入一般人续费↓</a-col>
                                </a-row>
                                <a-row v-if="item.ybrddprice">
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="一般人包注册价格" v-model:value="item.ybr_price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="一般人裸地址价格"
                                            v-model:value="item.ybr_price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input
                                            placeholder="一般人一次性价格" v-model:value="item.ybr_price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="一般人续费价格"
                                            v-model:value="item.ybr_price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="一般人包注册价格" v-model:value="item.ybr_price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="一般人裸地址价格"
                                            v-model:value="item.ybr_price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gsycx"><a-input
                                            placeholder="一般人一次性价格" v-model:value="item.ybr_price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="一般人续费价格"
                                            v-model:value="item.ybr_price14"></a-input></a-col>
                                </a-row>
                                <!-- 上级的价格 -->
                                <div style="margin-top: 10px;">
                                    <div>我的拿货价：</div>
                                    <div>设立小规模包注册{{
                                        state.other.company_postfix_p[item.name].price1 }}元，小规模裸地址{{
                                            state.other.company_postfix_p[item.name].price2 }}元，<span
                                            v-if="state.other.provide_adds.gsycx">小规模一次性{{
                                                state.other.company_postfix_p[item.name].price3 }}元，</span>小规模续费{{
                                                state.other.company_postfix_p[item.name].price4 }}元
                                        <a-divider type="vertical"></a-divider>
                                        迁入小规模包注册{{
                                            state.other.company_postfix_p[item.name].price11 }}元，小规模裸地址{{
                                            state.other.company_postfix_p[item.name].price12 }}元，<span
                                            v-if="state.other.provide_adds.gsycx">小规模一次性{{
                                                state.other.company_postfix_p[item.name].price13 }}元，</span>小规模续费{{
                                                state.other.company_postfix_p[item.name].price14 }}元
                                    </div>
                                    <div>设立一般人包注册{{
                                        state.other.company_postfix_p[item.name].ybr_price1
                                        }}元，一般人裸地址{{
                                            state.other.company_postfix_p[item.name].ybr_price2
                                        }}元，<span v-if="state.other.provide_adds.gsycx">一般人一次性{{
                                            state.other.company_postfix_p[item.name].ybr_price3
                                        }}元，</span>一般人续费{{
                                                state.other.company_postfix_p[item.name].ybr_price4
                                            }}元
                                        <a-divider type="vertical"></a-divider>
                                        迁入一般人包注册{{
                                            state.other.company_postfix_p[item.name].ybr_price11
                                        }}元，一般人裸地址{{
                                            state.other.company_postfix_p[item.name].ybr_price12
                                        }}元，<span v-if="state.other.provide_adds.gsycx">一般人一次性{{
                                            state.other.company_postfix_p[item.name].ybr_price13
                                            }}元，</span>一般人续费{{
                                                state.other.company_postfix_p[item.name].ybr_price14
                                            }}元
                                    </div>
                                </div>
                            </a-badge-ribbon>
                        </div>
                    </a-form-item>
                    <a-form-item label="个体价格" name="individual_postfix">
                        <a-radio-group button-style="solid" v-model:value="formState.individual_postfix_type">
                            <a-radio-button :value="1">自定义</a-radio-button>
                        </a-radio-group>
                        <div v-if="formState.individual_postfix_type == 1"
                            v-for="(item, index) in formState.individual_postfix_zdy" :key="index" class="phone-item"
                            style="margin-bottom: 20px; width: 900px">
                            <a-badge-ribbon placement="start">
                                <template #text>{{ item.name }}</template>
                                <a-row>
                                    <a-col :span="24"><a-divider :plain="true">代理商价格明细↓</a-divider></a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="3">设立小规模包注册↓</a-col>
                                    <a-col :span="3">设立小规模裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">设立小规模一次性↓</a-col>
                                    <a-col :span="3">设立小规模续费↓</a-col>
                                    <a-col :span="3">迁入小规模包注册↓</a-col>
                                    <a-col :span="3">迁入小规模裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">迁入小规模一次性↓</a-col>
                                    <a-col :span="3">迁入小规模续费↓</a-col>
                                </a-row>
                                <a-row>
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="包注册价格" v-model:value="item.price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="裸地址价格"
                                            v-model:value="item.price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input placeholder="一次性价格"
                                            v-model:value="item.price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="续费价格"
                                            v-model:value="item.price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="包注册价格" v-model:value="item.price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="裸地址价格"
                                            v-model:value="item.price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input placeholder="一次性价格"
                                            v-model:value="item.price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="续费价格"
                                            v-model:value="item.price14"></a-input></a-col>
                                </a-row>
                                <a-row v-if="item.xukeddprice">
                                    <a-col :span="3">设立许可包注册↓</a-col>
                                    <a-col :span="3">设立许可裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">设立许可一次性↓</a-col>
                                    <a-col :span="3">设立许可续费↓</a-col>
                                    <a-col :span="3">迁入许可包注册↓</a-col>
                                    <a-col :span="3">迁入许可裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">迁入许可一次性↓</a-col>
                                    <a-col :span="3">迁入许可续费↓</a-col>
                                </a-row>
                                <a-row v-if="item.xukeddprice">
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="许可包注册价格" v-model:value="item.xk_price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="许可裸地址价格"
                                            v-model:value="item.xk_price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input
                                            placeholder="许可一次性价格" v-model:value="item.xk_price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="许可续费价格"
                                            v-model:value="item.xk_price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="许可包注册价格" v-model:value="item.xk_price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="许可裸地址价格"
                                            v-model:value="item.xk_price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input
                                            placeholder="许可一次性价格" v-model:value="item.xk_price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="许可续费价格"
                                            v-model:value="item.xk_price14"></a-input></a-col>
                                </a-row>
                                <a-row v-if="item.ybrddprice">
                                    <a-col :span="3">设立一般人包注册↓</a-col>
                                    <a-col :span="3">设立一般人裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">设立一般人一次性↓</a-col>
                                    <a-col :span="3">设立一般人续费↓</a-col>
                                    <a-col :span="3">迁入一般人包注册↓</a-col>
                                    <a-col :span="3">迁入一般人裸地址↓</a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx">迁入一般人一次性↓</a-col>
                                    <a-col :span="3">迁入一般人续费↓</a-col>
                                </a-row>
                                <a-row v-if="item.ybrddprice">
                                    <!-- 设立 -->
                                    <a-col :span="3">
                                        <a-input placeholder="一般人包注册价格" v-model:value="item.ybr_price1"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="一般人裸地址价格"
                                            v-model:value="item.ybr_price2"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input
                                            placeholder="一般人一次性价格" v-model:value="item.ybr_price3"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="一般人续费价格"
                                            v-model:value="item.ybr_price4"></a-input></a-col>
                                    <!-- 迁入 -->
                                    <a-col :span="3">
                                        <a-input placeholder="一般人包注册价格" v-model:value="item.ybr_price11"></a-input>
                                    </a-col>
                                    <a-col :span="3"><a-input placeholder="一般人裸地址价格"
                                            v-model:value="item.ybr_price12"></a-input></a-col>
                                    <a-col :span="3" v-if="state.other.provide_adds.gtycx"><a-input
                                            placeholder="一般人一次性价格" v-model:value="item.ybr_price13"></a-input></a-col>
                                    <a-col :span="3"><a-input placeholder="一般人续费价格"
                                            v-model:value="item.ybr_price14"></a-input></a-col>
                                </a-row>
                                <!-- 上级的价格 -->
                                <div style="margin-top: 10px;">
                                    <div>我的拿货价：</div>
                                    <div>设立小规模包注册{{
                                        state.other.individual_postfix_p[item.name].price1 }}元，小规模裸地址{{
                                            state.other.individual_postfix_p[item.name].price2 }}元，<span
                                            v-if="state.other.provide_adds.gsycx">小规模一次性{{
                                                state.other.individual_postfix_p[item.name].price3 }}元，</span>小规模续费{{
                                                state.other.individual_postfix_p[item.name].price4 }}元
                                        <a-divider type="vertical"></a-divider>
                                        迁入小规模包注册{{
                                            state.other.individual_postfix_p[item.name].price11 }}元，小规模裸地址{{
                                            state.other.individual_postfix_p[item.name].price12 }}元，<span
                                            v-if="state.other.provide_adds.gsycx">小规模一次性{{
                                                state.other.individual_postfix_p[item.name].price13 }}元，</span>小规模续费{{
                                                state.other.individual_postfix_p[item.name].price14 }}元
                                    </div>
                                    <div>设立一般人包注册{{
                                        state.other.individual_postfix_p[item.name].ybr_price1
                                        }}元，一般人裸地址{{
                                            state.other.individual_postfix_p[item.name].ybr_price2
                                        }}元，<span v-if="state.other.provide_adds.gsycx">一般人一次性{{
                                            state.other.individual_postfix_p[item.name].ybr_price3
                                        }}元，</span>一般人续费{{
                                                state.other.individual_postfix_p[item.name].ybr_price4
                                            }}元
                                        <a-divider type="vertical"></a-divider>
                                        迁入一般人包注册{{
                                            state.other.individual_postfix_p[item.name].ybr_price11
                                        }}元，一般人裸地址{{
                                            state.other.individual_postfix_p[item.name].ybr_price12
                                        }}元，<span v-if="state.other.provide_adds.gsycx">一般人一次性{{
                                            state.other.individual_postfix_p[item.name].ybr_price13
                                            }}元，</span>一般人续费{{
                                                state.other.individual_postfix_p[item.name].ybr_price14
                                            }}元
                                    </div>
                                </div>
                            </a-badge-ribbon>
                        </div>
                    </a-form-item>
                    <a-form-item label="价格调整原因">
                        <a-input placeholder="价格调整原因" v-model:value="formState.price_reason"> </a-input>
                    </a-form-item>
                </div>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createMenu">
import { reactive, ref, onMounted, computed, watch, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { TreeProps } from 'ant-design-vue'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD HH:mm:ss'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {
    permissions: [{ required: true, message: '请选择菜单权限', trigger: 'change' }]
}
const fieldNames = {
    title: 'display_name',
    key: 'id',
    children: '_child'
}
const formLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 15 },
        sm: { span: 15 }
    }
}
interface platformServicesList {
    id: number
    name: string
    company_area_name: string
    company_city_name: string
    platform_name: string
    company_province_name: string
}
interface state {
    modalTitle: string
    loading: boolean
    unfold: boolean
    checkAll: boolean
    permissionList: any
    expandedKeys: (string | number)[]
    platformServicesList: platformServicesList[]
    options: any
    other: any
}
const state = reactive<state>({
    modalTitle: '编辑用户平台权限',
    loading: false,
    unfold: false,
    checkAll: false,
    permissionList: [],
    expandedKeys: [],
    // 平台选项信息
    platformServicesList: [],
    options: {}, //选中的平台,选项
    other: {}
})
interface formState {
    platform_id: number | null
    status: number
    between_time: string | null
    company_postfix_type: number
    company_postfix_zdy: any
    individual_postfix_type: number
    individual_postfix_zdy: any
    price_reason: string
}
let formState = reactive<formState>({
    platform_id: null,
    status: 1,
    between_time: '',
    company_postfix_type: 1, //自定义
    company_postfix_zdy: [], //自定义公司后缀
    individual_postfix_type: 1, //自定义
    individual_postfix_zdy: [],
    price_reason: ''
})
onMounted(() => {
    // 获取平台信息
    queryCompanyTypeList()
})
// 获取平台信息
const queryCompanyTypeList = () => {
    let requestParam = {
        url: '/admin/v1/tuiguang/platform',
        method: 'post',
        data: { type: 2 }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformServicesList = res.data
            //如果已经指定编辑的平台
            if (props.detailData.platform_id) {
                selectPlatformChange(null, { value: props.detailData.platform_id })
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        })
}
// 选择平台之后
const selectPlatformChange = (res, e) => {
    formState.platform_id = e.value
    state.loading = true
    // 获取平台选项信息，并设置已选中的默认值
    let requeryParam = {
        url: `/admin/v1/tuiguang/platformSet`,
        method: 'post',
        data: { userId: props.detailData.id, platformId: e.value }
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.loading = false
            state.options = res.data.options
            state.other = res.data.other
            Object.assign(formState, res.data.form)
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (formState.between_time) {
        array = formState.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        formState.between_time = str.join(',')
    } else {
        formState.between_time = null
    }
}

const onFormSubmit = () => {
    console.log(props.detailData.ids)
    console.log(Object.assign(formState, { userId: props.detailData.id, userIds: props.detailData.ids }))
    if (!formState.platform_id) {
        message.error('请选择平台')
        return
    }
    ruleForm.value.validate().then(() => {
        state.loading = true
        let requeryParam = {
            url: `/admin/v1/tuiguang/platformSetSave`,
            method: 'post',
            data: Object.assign(formState, { userId: props.detailData.id, userIds: props.detailData.ids })
        }
        baseService(requeryParam)
            .then((res: any) => {
                state.loading = false
                formState.price_reason = ''
                message.success(res.msg)
                emit('ok')
            })
            .catch((res) => {
                state.loading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    })
}
</script>

<style lang="less" scoped>
.tree {
    margin-top: 10px;
    border: 1px solid #d9d9d9;
}
</style>
